import * as THREE from "three";
import { useMemo } from "react";
import { HighlighterTool } from "@treegram/tools-highlighter";
import { createViewerTool, ViewerTool } from "@/hooks/viewer/use-viewer.ts";
import ThermicTypo from "@/models/enums/thermic-typo";
import SpaceTypo from "@/models/enums/space-typo";
import { ValidationMode } from "@/pages/takeoff/layouts/validation/layouts/details/types/validation-mode-type.ts";

import validationsTypes from "../models/validations-type.ts";
import thermalsType from "../models/thermals-type.ts";

const getApplyColor = (currentMode: ValidationMode, shellTypo: SpaceTypo | undefined, thermalTypo: ThermicTypo | undefined): string | undefined => {
    if (currentMode === "functional") {
        const normalizedShellKey =
            shellTypo === SpaceTypo.Balcon || shellTypo === SpaceTypo.Terrasse // Fusionné en SUexterieure
                ? SpaceTypo.SUexterieure
                : shellTypo;

        const element = validationsTypes.find(item => item.keyName === normalizedShellKey);
        return element?.color;
    }

    const element = thermalsType.find(item => item.keyName === thermalTypo);
    return element?.color;
};

const useValidationTools = (): ViewerTool[] =>
    useMemo<ViewerTool[]>(() => [
        createViewerTool({
            key: "highlighterTool",
            factory: (ctx) => new HighlighterTool(ctx.viewer),
            setup: async (tool) => {
                tool.updateOptions({
                    color: new THREE.Color("#FF0000"),
                    opacity: 1,
                    transparent: false,
                    renderedFaces: 1,
                    zoomToSelection: false
                });

                Object.values(ThermicTypo)
                    .filter(value => typeof value === "string").forEach((value, index) => {
                        tool.registerStyle(`Thermic-${value}`, {
                            color: new THREE.Color(getApplyColor("thermal", undefined, index)),
                            opacity: 1,
                            transparent: false,
                            renderedFaces: 1,
                            priority: 10
                        });
                    });

                Object.values(SpaceTypo)
                    .filter(value => typeof value === "string").forEach((value, index) => {
                        tool.registerStyle(`Space-${value}`, {
                            color: new THREE.Color(getApplyColor("functional", index, undefined)),
                            opacity: 1,
                            transparent: false,
                            renderedFaces: 1,
                            priority: 10
                        });
                    });

                await tool.activate();
            },
        }),
    ], []);


export default useValidationTools;